import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer_content">
        <div className="socialll">
          <a href="https://www.linkedin.com/in/maifooz-sheikh-18658177/" rel="noopener noreferrer" target="_blank">
            <LinkedInIcon sx={{  color: "white" }} />
          </a>
        </div>
        <div className="socialll">
          <a href="https://github.com/maifoozc" rel="noopener noreferrer" target="_blank">
            <GitHubIcon sx={{  color: "white" }}/>
          </a>
        </div>
      </div>

      <h6>Copyright@ Maifooz Sheikh</h6>
    </div>
  );
}

export default Footer;
